module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point2_1-83a3b4599d878b8179f25979a8675852.jpg";